import 'dayjs/locale/pl';
import dayjs from 'dayjs';

const formatDate = input => dayjs(input).locale('pl').format('D MMMM YYYY')

export default formatDate;
